import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MontoVueltoFormGroup = ({ iError, iTouched, montoRecibido, montoMedio1, setFieldValue }) => {
  React.useEffect(() => {
    const montoVuelto = montoRecibido ? montoRecibido - montoMedio1 : 0
    setFieldValue('montoVuelto', montoVuelto)
  }, [montoRecibido, montoMedio1, setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='VUELTO' htmlFor='input-montoVuelto' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='montoVuelto'>
          {({ field }) => <Form.InputNumber {...field} disabled isInvalid={iTouched && iError} id='input-montoVuelto' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoVueltoFormGroup)
